import Icon from '../components/Icon.vue'

Icon.register({
  'battery-empty': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M544 160h-480v192h480v-64h32v-64h-32v-64zM560 96c26.5 0 48 21.5 48 48v16h8c13.3 0 24 10.7 24 24v144c0 13.3-10.7 24-24 24h-8v16c0 26.5-21.5 48-48 48h-512c-26.5 0-48-21.5-48-48v-224c0-26.5 21.5-48 48-48h512z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/battery-empty.js
// module id = 652
// module chunks = 0